export default __webpack_public_path__ + "static/media/atm_short.784b512b.jpg";